import React from 'react';

import { Svg } from '@lglp/components';

import styles from './MaintenanceIcon.module.scss';

const MaintenanceIcon: React.FC<MaintenanceIconProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg
      viewBox="0 0 278 300.999"
      className={[styles.maintenanceIcon, className]}
      {...rest}
    >
      <path
        d="M1515.793 2038.036l10.116-13.336a59.256 59.256 0 0 0 18.376 0l10.106 13.335a4.712 4.712 0 0 0 6.092 1.241l24.5-14.022a4.7 4.7 0 0 0 1.993-5.911l-6.544-15.393a56.508 56.508 0 0 0 9.134-15.776l16.685-2.05a4.7 4.7 0 0 0 4.131-4.662V1953.4a4.7 4.7 0 0 0-4.131-4.663l-16.684-2.048a56.733 56.733 0 0 0-9.135-15.791l6.543-15.377a4.7 4.7 0 0 0-1.991-5.912l-24.5-14.022a4.711 4.711 0 0 0-6.092 1.241l-10.1 13.332a58.006 58.006 0 0 0-18.381 0l-10.113-13.333a4.712 4.712 0 0 0-6.091-1.239l-24.5 14.022a4.7 4.7 0 0 0-1.991 5.912l6.542 15.377a56.736 56.736 0 0 0-9.135 15.791l-16.683 2.048a4.7 4.7 0 0 0-4.131 4.663v28.063a4.7 4.7 0 0 0 4.131 4.662l16.685 2.05a56.508 56.508 0 0 0 9.134 15.776l-6.544 15.393a4.7 4.7 0 0 0 1.993 5.911l24.5 14.022a4.713 4.713 0 0 0 6.085-1.242zm-8.935-70.615a28.235 28.235 0 1 1 28.235 28.19 28.244 28.244 0 0 1-28.235-28.19z"
        className={styles.cls1}
        transform="translate(-1394.152 -1803.273)"
      />
      <g>
        <path
          d="M1484.79 2111.156a5.847 5.847 0 0 0-1.536-8.147 128.911 128.911 0 0 1-56.49-106.548c0-71.118 58.054-128.975 129.41-128.975h3.446l-13.486 13.441a5.847 5.847 0 0 0 0 8.291 5.9 5.9 0 0 0 8.317 0l23.525-23.446a6.01 6.01 0 0 0 .738-.9c.1-.144.162-.3.244-.45a6.022 6.022 0 0 0 .3-.558 5.733 5.733 0 0 0 .185-.6c.05-.167.115-.327.149-.5a5.853 5.853 0 0 0 .115-1.131v-.037a5.829 5.829 0 0 0-.115-1.129c-.034-.172-.1-.333-.149-.5a5.636 5.636 0 0 0-.185-.6 6.05 6.05 0 0 0-.3-.56c-.082-.149-.149-.3-.244-.448a6.01 6.01 0 0 0-.738-.9l-23.525-23.446a5.872 5.872 0 0 0-8.317 8.291l13.486 13.443h-3.446c-77.845 0-141.175 63.117-141.175 140.7a140.616 140.616 0 0 0 61.614 116.225 5.894 5.894 0 0 0 8.177-1.516z"
          className={styles.cls1}
          transform="translate(-1415 -1832.311)"
        />
        <ellipse
          cx="135.89"
          cy="134.86"
          rx="135.89"
          ry="134.86"
          className={styles.cls2}
          transform="translate(5.219 30.279)"
        />
      </g>
    </Svg>
  );
};

type MaintenanceIconProps = {
  className?: string[] | string;
};

export default MaintenanceIcon;
